import { createApiClient } from '@cutover/api'
import { ApiError as ApiErrorType, httpGatewayAdapter } from './http-gateway-adapter'

export type ApiError = ApiErrorType

export const apiClient = createApiClient({ requestAdapter: options => httpGatewayAdapter(options) })
